module.exports = __webpack_public_path__ + "static/img/toWeappBj.7afb998.png";